import React from 'react';
import { FaGlobe } from 'react-icons/fa';
import Select from 'react-select';
import './styles/forretningsdetaljer.css';

const PRODUCTS = [
  { value: 'website', label: 'Hjemmeside', icon: '🌐' },
  { value: 'video', label: 'Video', icon: '🎥' },
  { value: 'marketing', label: 'Marketing', icon: '📢' },
  { value: 'automation', label: 'Automatisering', icon: '⚡' }
];

const PAYMENT_TYPES = [
  { value: 'oneTime', label: 'Enkeltbeløb', icon: '💰' },
  { value: 'subscription', label: 'Abonnement', icon: '🔄' }
];

const CustomOption = ({ children, ...props }) => {
  const { data } = props;
  return (
    <div
      {...props.innerProps}
      className={`crm-business__option ${props.isFocused ? 'crm-business__option--is-focused' : ''} ${props.isSelected ? 'crm-business__option--is-selected' : ''}`}
    >
      <span className="crm-business__option-icon">{data.icon}</span>
      {children}
    </div>
  );
};

const CustomMultiValue = ({ children, ...props }) => {
  const { data } = props;
  return (
    <div className="crm-business__multi-value">
      <span className="crm-business__value-icon">{data.icon}</span>
      <span className="crm-business__value-label">{children}</span>
    </div>
  );
};

const Forretningsdetaljer = ({ formData, handleChange, handleArrayChange }) => {
  const handleWebsiteChange = (e) => {
    let url = e.target.value;
    // Fjern eventuelle protokoller fra input
    url = url.replace(/^(https?:\/\/)?(www\.)?/i, '');
    
    handleChange({
      target: {
        name: 'websiteUrl',
        value: url
      }
    });
  };

  const openWebsite = () => {
    if (!formData.websiteUrl) return;
    
    // Tilføj https:// hvis det mangler
    let url = formData.websiteUrl;
    if (!url.match(/^https?:\/\//i)) {
      url = 'https://' + url;
    }
    window.open(url, '_blank');
  };

  return (
    <div className="form-section crm-business">
      <div className="section-header">
        <div className="header-title">
          <span className="section-icon">💼</span>
          <div>
            <h3>Forretningsdetaljer</h3>
            <div className="section-description">
              Økonomiske og forretningsmæssige oplysninger
            </div>
          </div>
        </div>
      </div>

      <div className="crm-business__content">
        <div className="crm-business__grid">
          <div className="crm-business__group">
            <label className="crm-business__label">Produkter</label>
            <Select
              isMulti
              name="products"
              options={PRODUCTS}
              value={PRODUCTS.filter(p => formData.products?.includes(p.value))}
              onChange={(selected) => {
                const values = selected ? selected.map(item => item.value) : [];
                handleArrayChange('products', values);
              }}
              components={{
                Option: CustomOption,
                MultiValue: CustomMultiValue,
                ClearIndicator: () => null,
                IndicatorSeparator: () => null
              }}
              className="crm-business__select-container"
              classNamePrefix="crm-business"
              placeholder="Vælg produkter..."
              noOptionsMessage={() => "Ingen produkter fundet"}
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              isSearchable={true}
              menuPlacement="auto"
            />
          </div>

          <div className="crm-business__group">
            <label className="crm-business__label">Betalingstype</label>
            <Select
              name="paymentType"
              value={PAYMENT_TYPES.find(t => t.value === formData.paymentType)}
              onChange={(selected) => {
                handleChange({
                  target: {
                    name: 'paymentType',
                    value: selected ? selected.value : ''
                  }
                });
              }}
              options={PAYMENT_TYPES}
              components={{
                Option: CustomOption,
                SingleValue: CustomMultiValue,
                ClearIndicator: () => null,
                IndicatorSeparator: () => null
              }}
              className="crm-business__select-container"
              classNamePrefix="crm-business"
              placeholder="Vælg betalingstype..."
              noOptionsMessage={() => "Ingen betalingstyper fundet"}
              isSearchable={false}
              menuPlacement="auto"
            />
          </div>
        </div>

        <div className="crm-business__group">
          <label className="crm-business__label">
            <FaGlobe className="crm-business__label-icon" />
            Hjemmeside
          </label>
          <div className="crm-business__url-container">
            <div className="crm-business__url-prefix">
              <FaGlobe className="crm-business__prefix-icon" />
              <span>https://</span>
            </div>
            <div className="crm-business__input-wrapper">
              <input
                type="text"
                name="websiteUrl"
                value={formData.websiteUrl}
                onChange={handleWebsiteChange}
                placeholder="pariabranding.dk"
                className="crm-business__input"
              />
            </div>
            <button 
              type="button"
              onClick={openWebsite}
              className="crm-business__url-button"
              title="Åbn hjemmeside"
              disabled={!formData.websiteUrl}
            >
              <span className="crm-business__button-text">Åbn</span>
              <FaGlobe className="crm-business__button-icon" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forretningsdetaljer;
